import { PaymentModePolicy } from "constants/charge/PaymentModePolicy";
import { ResponseEntity } from "domain/entity/Common/ResponseEntity";
import { EMPTY_LET_PASS_ACCOUNT_ENTITY, LetPassAccountEntity } from "domain/entity/LetPassAccount/LetPassAccountEntity";
import { EMPTY_LET_PASS_ACCOUNT_SEARCH_CRITERIA, LetPassAccountSearchCriteria } from "domain/entity/LetPassAccount/LetPassAccountSearchCriteria";
import { BankerRepository } from "domain/repository/Banker/BankerRepo";
import { CompanyRepository } from "domain/repository/Company/CompanyRepo";
import { LetPassAccountRepository } from "domain/repository/LetPassAccount/LetPassAccountRepo";
import _ from "lodash";
import { createLetPassAccountPOValidationSchema, createLetPassAccountValidationSchema } from "presentation/constant/LetPassAccount/LetPassAccountValidationSchema";
import { Validation } from "presentation/constant/Validation";
import { LetPassAccountModel } from "presentation/model/LetPassAccount/LetPassAccountModel";
import { formatNumber, formatStrToNumber } from "presentation/utils/numberUtil";
import { Dispatch, SetStateAction } from "react";
import { IFieldValue } from "veronica-ui-component/dist/component/core";
import BaseViewModel from "../BaseViewModel";

interface LetPassAccountVMProps extends BaseViewModel {
    dispatch: [
        Dispatch<SetStateAction<LetPassAccountModel>> | ((value: SetStateAction<LetPassAccountModel>) => void),
    ],
    repo: LetPassAccountRepository,
    companyRepo: CompanyRepository,
    bankerRepo: BankerRepository,
}

export const LetPassAccountVM = ({ dispatch, repo, bankerRepo, companyRepo }: LetPassAccountVMProps) => {
    const [letPassAccountDispatch] = dispatch;

    const loadDropdownOption = async () => {
        const [companies, bankers] = await Promise.all([
            companyRepo.getAllCompanyForCombobox(),
            bankerRepo.getEntities()
        ]);
        /*await companyRepo.getAllCompanyForCombobox().then(
            companies => {*/
        let newCompanies = companies?.filter(entity => entity.customerType !== 'SL' && entity.companyType !== 'MASTER' && entity.companyType !== 'ALLIANCE');
        let companyCodeDropdownOption = newCompanies?.map((company) => ({
            dropdownLabel: company.companyCode,
            tagLabel: company.companyCode,
            value: company.companyCode,
        })) ?? []
        companyCodeDropdownOption = _.orderBy(companyCodeDropdownOption, "dropdownLabel");

        /*letPassAccountDispatch(prevState => ({
            ...prevState,
            dynamicOptions: {
                ...prevState.dynamicOptions,
                companyCodeDropdownOptions: companyCodeDropdownOption,

            }
        }))
    }
);*/

        /*await bankerRepo.getEntities().then(
            bankers => {*/
        let newBankers = bankers?.filter(entity => entity.activeInd === 'Y');
        let bankCodeDropdownOption = newBankers?.map((banker) => ({
            dropdownLabel: banker.bankCode,
            tagLabel: banker.bankCode,
            value: banker.bankCode,
        })) ?? []
        bankCodeDropdownOption = _.orderBy(bankCodeDropdownOption, "dropdownLabel");

        /*letPassAccountDispatch(prevState => ({
            ...prevState,
            dynamicOptions: {
                ...prevState.dynamicOptions,
                bankCodeDropdownOptions: bankCodeDropdownOption,
            }
        }))
    }        
);*/
        letPassAccountDispatch(prevState => ({
            ...prevState,
            dynamicOptions: {
                ...prevState.dynamicOptions,
                companyCodeDropdownOptions: companyCodeDropdownOption,
                bankCodeDropdownOptions: bankCodeDropdownOption
            }
        }))
    }

    const getTransactionAmount = async (defaultCompanyCode: string) => {
        let searchCriteria = { ...EMPTY_LET_PASS_ACCOUNT_SEARCH_CRITERIA };
        searchCriteria = {
            ...searchCriteria,
            companyCode: defaultCompanyCode,
        }
        const data = await repo.getEntities(searchCriteria);
        if (data && data.length > 0) {
            return data[0].lpaBalance;
        } else {
            return 0;
        }
    }

    const onSearch = async (searchCriteria: LetPassAccountSearchCriteria) => {
        letPassAccountDispatch(prevState => {
            return {
                ...prevState,
                auditLogList: [],
                isEdit: false,
                isShowEditPanel: false,
            }
        });

        await repo.getEntities(searchCriteria).then((data) => {
            letPassAccountDispatch(prevState => {
                return {
                    ...prevState,
                    letPassAccountList: data,
                    lpaBanlance: data.length > 0 ? data[0].lpaBalance : 0,
                    isShowEditPanel: false,
                    isAdd: false,
                    isEdit: false,
                }
            });
        });
    }

    const onCloseEidtPanel = async () => {
        letPassAccountDispatch(prevState => {
            return {
                ...prevState,
                currentEditRow: { ...EMPTY_LET_PASS_ACCOUNT_ENTITY },
                isShowEditPanel: false,
                isAdd: false,
                isEdit: false,
                masterState: {
                    ...prevState.masterState,
                    allFormState: {
                    },
                }
            }
        });
    }

    const onSave = async (row: LetPassAccountEntity) => {
        const valResult = await Validation(row.paymentMode !== 'PO' ? createLetPassAccountValidationSchema : createLetPassAccountPOValidationSchema).ValidateFormOnly(row);
        let validatedResult: { [x: string]: string } = {};
        if (valResult) {
            validatedResult = { ...valResult };

            letPassAccountDispatch(prevState => {
                return {
                    ...prevState,
                    masterState: {
                        ...prevState.masterState,
                        allFormState: {
                            ...validatedResult
                        },
                    }
                }
            });

            const res: ResponseEntity = {
                code: "",
                success: false,
                msg: null,
                data: null
            }

            return res;
        }
        return await repo.onSave(row);
    }

    const onPrintReport = async (ids: number[]) => {
        let msg = '';
        await repo.onPrintReport(ids).then(data => {
            if (data && data.success) {
                for (const key in data.data) {
                    const dat = data.data;
                    if (dat[key] != null && dat[key] !== undefined) {
                        const tempData = dat[key] as string;

                        let base64 = tempData
                        let bstr = atob(base64)
                        let n = bstr.length
                        let u8arr = new Uint8Array(n)
                        while (n--) {
                            u8arr[n] = bstr.charCodeAt(n)
                        }
                        const blob = new Blob([u8arr], { type: 'application/pdf' });
                        const url = URL.createObjectURL(blob);

                        window.open(url, '_blank');
                        URL.revokeObjectURL(url);
                    }
                };
            } else {
                msg = data.data ?? "Print report failed.";
            }
        });
        letPassAccountDispatch(prevState => {
            return {
                ...prevState,
                isShowEditPanel: false,
                isAdd: false,
                isEdit: false,
            }
        });
        return msg;
    }

    const onFieldChange = async (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;

        if ('paymentMode' === fieldKey) {
            letPassAccountDispatch(prevState => {
                return {
                    ...prevState,
                    currentEditRow: {
                        ...prevState.currentEditRow,
                        [fieldKey]: val,
                        payOrderNo: val !== 'PO' ? '' : prevState.currentEditRow.payOrderNo
                    },
                    masterState: {
                        ...prevState.masterState,
                        allFormState: {
                            ...prevState.masterState.allFormState,
                            [fieldKey]: '',
                            payOrderNo: '',
                        },
                    }
                }
            })
        } else {
            letPassAccountDispatch(prevState => {
                return {
                    ...prevState,
                    currentEditRow: {
                        ...prevState.currentEditRow,
                        [fieldKey]: val,
                    },
                    masterState: {
                        ...prevState.masterState,
                        allFormState: {
                            ...prevState.masterState.allFormState,
                            [fieldKey]: ''
                        },
                    }
                }
            })
        }
    }

    const updateTransactionAmount = async (companyCode: any) => {
        let amount = 0;
        amount = await getTransactionAmount(companyCode);
        letPassAccountDispatch(prevState => {
            return {
                ...prevState,
                currentEditRow: {
                    ...prevState.currentEditRow,
                    transactionAmount: formatStrToNumber(formatNumber(amount, 2))
                },
            }
        })
    }

    const onCheckboxChange = (checked: boolean, fieldName: string) => {
        letPassAccountDispatch(prevState => {
            return {
                ...prevState,
                currentEditRow: {
                    ...prevState.currentEditRow,
                    [fieldName]: checked ? "Y" : "N",
                },
            }
        })
    }

    const onResetClick = async (isAdd: boolean) => {
        letPassAccountDispatch(prevState => {
            return {
                ...prevState,
                currentEditRow: isAdd ? { ...EMPTY_LET_PASS_ACCOUNT_ENTITY } : prevState.currentRow,
            }
        })
    }

    const onEditClick = async (defaultCompanyCode: string | null, userName: string, transType: string, operatingUnit: string) => {
        if (transType === 'Edit') {
            letPassAccountDispatch(prevState => {
                return {
                    ...prevState,
                    isEdit: true,
                    isShowEditPanel: true,
                    isShowSearchPanel: false,
                    currentEditRow: prevState.selectedRows[0],
                }
            })

        } else {
            let amount = 0;
            if (transType === 'Closure') {
                if (defaultCompanyCode) {
                    amount = await getTransactionAmount(defaultCompanyCode);
                }
            }
            letPassAccountDispatch(prevState => {
                return {
                    ...prevState,
                    isShowSearchPanel: false,
                    dynamicOptions: {
                        ...prevState.dynamicOptions,
                        paymentModeDropdownOptions: PaymentModePolicy().getPaymentModeDroOptsFor(transType, operatingUnit)

                    },
                    isShowEditPanel: true,
                    currentEditRow: {
                        ...EMPTY_LET_PASS_ACCOUNT_ENTITY,
                        transactionType: transType,
                        transactionDesc: transType,
                        createdBy: userName,
                        transactionDate: new Date(),
                        companyCode: prevState.dynamicOptions.companyCodeDropdownOptions.length > 0 ? prevState.dynamicOptions.companyCodeDropdownOptions[0].value : null,
                        paymentMode: PaymentModePolicy().getPaymentModeDroOptsFor(transType, operatingUnit).length > 0 ? PaymentModePolicy().getPaymentModeDroOptsFor(transType, operatingUnit)[0].value : null,
                        bankCode: prevState.dynamicOptions.bankCodeDropdownOptions.length > 0 ? prevState.dynamicOptions.bankCodeDropdownOptions[0].value : null,
                        transactionAmount: transType === 'Closure' ? formatStrToNumber(formatNumber(amount, 2)) : null
                    },
                }
            })
        }
    }

    const updateSelectedRows = async (rows: LetPassAccountEntity[]) => {

        letPassAccountDispatch(prevState => {
            return {
                ...prevState,
                selectedRows: rows,
                forceRefresh: !prevState.forceRefresh
            }
        })
    }

    const onRemoveAllSearchCriteria = async () => {
        letPassAccountDispatch(prevState => {
            return {
                ...prevState, searchCriteria: { ...EMPTY_LET_PASS_ACCOUNT_SEARCH_CRITERIA },
            }
        })
    }

    const onSearchClick = async () => {
        letPassAccountDispatch(prevState => {
            return {
                ...prevState,
                isShowSearchPanel: !prevState.isShowSearchPanel,
            }
        })
    }

    const onSearchFieldChange = async (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;

        letPassAccountDispatch(prevState => {
            return {
                ...prevState,
                searchCriteria: {
                    ...prevState.searchCriteria,
                    [fieldKey]: val,
                },
            }
        })
    }

    const onDateRangeChange = (startDate: any, endDate: any, dateFields: { startField: string, endField: string }) => {
        letPassAccountDispatch(prevState => ({
            ...prevState,
            searchCriteria: {
                ...prevState.searchCriteria,
                [dateFields.startField]: startDate,
                [dateFields.endField]: endDate,
            }
        }))
    }

    const onRefreshBankCode = (paymentMode: string | null | undefined, defBankCode: string) => {
        letPassAccountDispatch(prevState => ({
            ...prevState,
            currentEditRow: {
                ...prevState.currentEditRow,
                bankCode: paymentMode === 'PO' ? defBankCode : ''
            }

        }))
    }

    const onSaveClicked = () => {
        letPassAccountDispatch(prevState => {
            return {
                ...prevState,
                masterState: {
                    ...prevState.masterState,
                    isSaveClicked: true,
                    allFormState: {},
                }
            }
        })
    }

    return {
        onPrintReport: onPrintReport,
        onSearchClick: onSearchClick,
        loadDropdownOption: loadDropdownOption,
        onDateRangeChange: onDateRangeChange,
        onSearchFieldChange: onSearchFieldChange,
        onRemoveAllSearchCriteria: onRemoveAllSearchCriteria,
        onSave: onSave,
        onSearch: onSearch,
        getTransactionAmount,
        updateSelectedRows: updateSelectedRows,
        onEditClick: onEditClick,
        onResetClick: onResetClick,
        onCheckboxChange: onCheckboxChange,
        onFieldChange: onFieldChange,
        onCloseEidtPanel: onCloseEidtPanel,
        onRefreshBankCode: onRefreshBankCode,
        updateTransactionAmount: updateTransactionAmount,
        onSaveClicked: onSaveClicked,

    }
}